/** 画面に表示する日時の共通タイムゾーン。 */
export const DISPLAY_TIME_ZONE = "Asia/Tokyo";

const TIMEZONELESS_DATE_TIME = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(?:\.\d+)?$/;

/** API の timezone 無し日時は UTC として解釈する。 */
export function parseApiDateTime(value: string): Date {
	const normalized = TIMEZONELESS_DATE_TIME.test(value) ? `${value.replace(" ", "T")}Z` : value;
	return new Date(normalized);
}
